export const RECEIPT_PRINT_ROOT = 'xsib-receipt-print'

export const RECEIPT_WIDTH_MM = 80
export const RECEIPT_CONTENT_MM = 72

const CSS_PX_PER_MM = 96 / 25.4

/**
 * `size: 80mm auto` yaroqsiz — Chromium uni tashlab yuboradi va printer standart varag'ini oladi.
 * Shuning uchun bet uzunligi chekning o'lchangan balandligidan beriladi.
 */
export function receiptPrintCss(lengthMm?: number): string {
  const size = lengthMm ? `size: ${RECEIPT_WIDTH_MM}mm ${lengthMm}mm; ` : ''
  return `
  .${RECEIPT_PRINT_ROOT} { position: fixed; top: 0; left: 0; visibility: hidden; pointer-events: none; }
  @media print {
    @page { ${size}margin: 0; }
    html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    body > *:not(.${RECEIPT_PRINT_ROOT}) { display: none !important; }
    .${RECEIPT_PRINT_ROOT} { position: static; visibility: visible; width: ${RECEIPT_WIDTH_MM}mm; }
  }
`
}

export function receiptLengthMm(heightPx: number): number {
  return Math.ceil(heightPx / CSS_PX_PER_MM)
}

export const RECEIPT_STYLE_ID = 'xsib-receipt-print-css'

/** Chop etishdan oldin, logotip yuklangach chaqiriladi — bet chek uzunligiga teng bo'ladi. */
export function fitReceiptPage(): void {
  const root = document.querySelector<HTMLElement>(`.${RECEIPT_PRINT_ROOT}`)
  const style = document.getElementById(RECEIPT_STYLE_ID)
  if (root && style) style.textContent = receiptPrintCss(receiptLengthMm(root.getBoundingClientRect().height))
}

export const RECEIPT_FONT = '"DejaVu Sans Mono", "Liberation Mono", "Courier New", monospace'

export const RECEIPT_LOGO_MAX_HEIGHT_MM = 18

const LOGO_WAIT_MS = 3000

/** Logotip yuklanishini kutadi; ochilmasa ham chek chiqadi — pul olingan, chek kerak. */
export async function receiptImagesSettled(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${RECEIPT_PRINT_ROOT} img`))
  const decodes = images.map((image) => image.decode().catch(() => undefined))
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, LOGO_WAIT_MS))
  await Promise.race([Promise.all(decodes).then(() => undefined), timeout])
}
